export default __webpack_public_path__ + "static/media/helen_kin_song.d30906ca.mp3";